import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';
import { Switch } from 'react-router';
import {
    IonRouterOutlet,
  } from '@ionic/react';

//Components
import Login from "./pages/login";
import OtpVerification from "./pages/otpVerification";
import Delivery from "./pages/newDelivery";
import Payment from "./pages/payment";
import ReviewBookingAndConfirm from "./pages/confirmation";
import Deliveries from "./components/AllDeliveriesComponent";
import Dashboard from "./pages/dashboard";
import Landing from "./pages/landing/LandingPage";
import SignUp from "./pages/signUp"
import Delivery2 from "./pages/newDelivery2";
import Payment2 from "./pages/payment2";
import ReviewBookingAndConfirm2 from "./pages/confirmation2";




// New Routes
import LandingComponent from './newCodeRefactored/pages/landing';
import LoginComponent from './newCodeRefactored/pages/userLogin';
import SignUpComponent from './newCodeRefactored/pages/userRegistration';

import NewBookingComponent from "./newCodeRefactored/pages/booking";
import DeliveriesComponent from './newCodeRefactored/pages/deliveries';
import DashboardComponent from './newCodeRefactored/pages/dashboard';

import { useRecoilValue } from "recoil";
import { userLoggedIn, getUserRydeSendToken } from "../src/newCodeRefactored/store/selectors/userDetailSelector";


function PrivateRoute({ isAuthenticated , component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/new/login', state: { from: props.location } }} />
        )
      }
    />
  );
}


export default function Routes() {

    let a = useRecoilValue(userLoggedIn)
    let b = useRecoilValue(getUserRydeSendToken)
    return (
        <IonReactRouter>
            <Switch>
                {/*  DELETE THESE ROUTES  */}
                {/* PUBLIC ROUTES */}
                <Route exact path="/login">
                    <Login/>
                </Route>
                <Route exact path="/verification">
                    <OtpVerification/>
                </Route>
                <Route exact path="/booking">
                    <Delivery/>
                </Route>
                <Route exact path="/payment">
                    <Payment/>
                </Route>
                <Route exact path="/confirm">
                    <ReviewBookingAndConfirm/>
                </Route>
                
                
                {/* NEW ROUTES */}
                <Route exact path="/deliveries">
                    <Deliveries/>
                </Route>
                <Route exact path="/dashboard">
                    <Dashboard/>
                </Route>
                <Route exact path="/signup">
                    <SignUp/>
                </Route>
                <Route exact path="/rydeSend">
                    <Landing/>
                </Route>
                <Route exact path="/">
                    <Redirect to="/rydeSend" />
                </Route>
                
                {/*  DELETE THESE ROUTES  */}










                { /* PERFECT NEW ROUTES */}
                {/* PUBLIC ROUTES */}
                
                {/* PUBLIC ROUTES */}
                <Route exact path="/new/rydeSend">
                    <LandingComponent/>
                </Route>
                <Route exact path="/new/login">
                    <LoginComponent/>
                </Route>
                <Route exact path="/new/signup">
                    <SignUpComponent/>
                </Route>
                
                { /* PRIVATE ROUTES */}

                <PrivateRoute path="/new/booking" component={NewBookingComponent} isAuthenticated={a} />
                <PrivateRoute path="/new/deliveries" component={DeliveriesComponent} isAuthenticated={a} />
                <PrivateRoute path="/new/dashboard" component={DashboardComponent} isAuthenticated={a} /> 

                { /* PRIVATE ROUTES */}

                {/**DELETE ME */}

                {/* <Route exact path="/new/booking">
                    <NewBookingComponent/>
                </Route>
                <Route exact path="/new/deliveries">
                    <DeliveriesComponent/>
                </Route>
                <Route exact path="/new/dashboard">
                    <DashboardComponent/>
                </Route> */}
                
                {/**DELETE ME */}
                
                { /* PERFECT NEW ROUTES */}














            </Switch>
        </IonReactRouter> 
    )
}